// extracted by css-extract-rspack-plugin
export default {"authContainer":"auth-container--YTL6Qgo62YkUK4Uo"};